<template>
  <div  @click="exitFilterMobile" class="contentBox drRtl">
    <div v-if="$root.globalData"  class="contentBox__text">
      <h1>{{ $root.globalData.keys.main_title1 }}</h1>
      <p>{{ $root.globalData.keys.main_description1 }}</p>
    </div>

    <div id="contentBox__CategorySearch" v-if="$root.globalData"  class="contentBox__CategorySearch">
      <div class="boxes">
        <div style="paddingbottom: 10px" class="filter__box">
          <!-- <p v-on:click="filterShow(0)"> -->
            <MapIcon />
            <input
              type="text"
              @change="window.alert(1)"
              id="searchIndustry"
              :placeholder="$root.globalData.keys.searchbox_keyword"
              v-model="search"
            />
          <!-- </p> -->
          <!-- <template v-if="filterShowing[0]">
            <div class="fiter__content" data-aos="fade-up">
              <form action="">
                <input type="text" name="" id="" />
              </form>
              <div class="filter__items">
                <p>ایتم یک</p>
                <p>ایتم دو</p>
                <p>ایتم سه</p>
                <p>ایتم چهار</p>
                <p>ایتم پنج</p>
              </div>
            </div>
          </template> -->
        </div>
        <template v-if="unitsFilter">
          <div class="filter__box">
            <v-autocomplete
              v-if="windowSize > 1000"
              class="unitsFilter"
              v-model="selectedCountry"
              :items="countries"
              :label="$root.globalData.keys.searchbox_country"
              item-text="name"
              item-value="id"
              multiple
              prepend-icon="mdi-flag"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ selectedCountry.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>

            <v-select
            :menu-props="{
          closeOnClick: true,
          closeOnContentClick: true
        }"
              v-else
              class="unitsFilter"
              v-model="selectedCountry"
              :items="countries"
              :label="$root.globalData.keys.searchbox_country"
              item-text="name"
              item-value="id"
              multiple
              prepend-icon="mdi-flag"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ selectedCountry.length - 1 }} )
                </span>
              </template>
            </v-select>
          </div>

          <div class="filter__box">
            <v-autocomplete
              v-if="windowSize > 1000"
              v-model="selectedProvinces"
              :items="provinces"
              :label="$root.globalData.keys.searchbox_province"
              item-text="name"
              item-value="id"
              multiple
              prepend-icon="mdi-map-marker"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ selectedProvinces.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>

            <v-select
            :menu-props="{
          closeOnClick: true,
          closeOnContentClick: true
        }"
              v-else
              v-model="selectedProvinces"
              :items="provinces"
              :label="$root.globalData.keys.searchbox_province"
              item-text="name"
              item-value="id"
              multiple
              prepend-icon="mdi-map-marker"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ selectedProvinces.length - 1 }} )
                </span>
              </template>
            </v-select>
          </div>

          <div class="filter__box">
            <v-autocomplete
              v-if="windowSize > 1000"
              class="unitsFilter"
              v-model="selectedCity"
              :items="cities"
              :label="$root.globalData.keys.searchbox_city"
              item-text="name"
              item-value="id"
              multiple
              prepend-icon="mdi-map"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ selectedCity.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>

            <v-select
            :menu-props="{
          closeOnClick: true,
          closeOnContentClick: true
        }"
              v-else
              class="unitsFilter"
              v-model="selectedCity"
              :items="cities"
              :label="$root.globalData.keys.searchbox_city"
              item-text="name"
              item-value="id"
              multiple
              prepend-icon="mdi-map"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ selectedCity.length - 1 }} )
                </span>
              </template>
            </v-select>
          </div>
        </template>

        <div class="filter__category__search">
          <button @click="filter()" type="button">
            {{ $root.globalData.keys.searchbox_button }}
          </button>
        </div>
      </div>
    </div>

    <div class="contentBox__hashtags drRtl">
      <!-- <span v-for="(item, index) in hashtags" :key="index"> {{ item }} </span> -->
    </div>

    <div v-if="homeData" class="category__logo">
      <!-- <div
        class="category__logo__content"
        v-for="(item, index) in homeData.last_industryCategories"
        :key="index"
        @click="showIndustry(item.id)"
      >
        <img
          class="industryIcon"
          width="90"
          height="90"
          :src="item.image"
          :alt="item.title"
        />
        <span>{{ item.title }}</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import FactoryLogo from "../svgs/FactoryLogo.vue";
import SearchIcon from "../svgs/SearchIcon.vue";
import MapIcon from "../svgs/MapIcon.vue";
import FilterIcon from "../svgs/FilterIcon.vue";
import CityIcon from "../svgs/CityIcon.vue";
import LocationIcon from "../svgs/LocationIcon.vue";
import RegionIcon from "../svgs/RegionIcon.vue";
import Callicon from "../svgs/Callicon.vue";
import CategoryFilterIcon from "../svgs/CategoryFilterIcon.vue";
import EarthIcon from "../svgs/EarthIcon.vue";
import MapIcon1 from "../svgs/MapIcon.vue";
export default {
  data() {
    return {
      search: "",
      windowSize: 1920,
      selectedCity: [],
      selectedProvinces: [],
      selectedCountry: [],

      country: null,
      countryList: [
        { name: "ایران", id: 1 },
        { name: "پاکستان", id: 2 },
        { name: "ایتالیا", id: 3 },
        { name: "آلمان", id: 4 },
        { name: "فرانسه", id: 5 },
        { name: "هند", id: 6 },
        { name: "هلند", id: 7 },
        { name: "عربستان", id: 8 },
        { name: "امارات", id: 9 },
        { name: "چین", id: 10 },
        { name: "کره", id: 11 },
        { name: "ژاپن", id: 12 },
        { name: "گرجستان", id: 13 },
        { name: "تایلند", id: 14 },
        { name: "قبرس", id: 15 },
        { name: "مکزیک", id: 16 }
      ],
      helpCountryList: [
        { name: "ایران", id: 1 },
        { name: "پاکستان", id: 2 },
        { name: "ایتالیا", id: 3 },
        { name: "آلمان", id: 4 },
        { name: "فرانسه", id: 5 },
        { name: "هند", id: 6 },
        { name: "هلند", id: 7 },
        { name: "عربستان", id: 8 },
        { name: "امارات", id: 9 },
        { name: "چین", id: 10 },
        { name: "کره", id: 11 },
        { name: "ژاپن", id: 12 },
        { name: "گرجستان", id: 13 },
        { name: "تایلند", id: 14 },
        { name: "قبرس", id: 15 },
        { name: "مکزیک", id: 16 }
      ],

      filterShowing: [false, false, false, false],
      filterCategoryBox: 4,
      factoryItems: 5,
      headerTitle: "بانک اطلاعات صنایع و مراکز تولیدی",
      headerDesc: "رشیو بیش از ۳۰۰.۰۰۰ کارخانه، کارگاه تولیدی",
      hashtags: [
        "#شهرک صنعتی آق_قلا",
        "#کارخانه_سیمان_بجنورد",
        "#کارخانه_شالی_رستگار"
      ]
    };
  },
  computed: {
    unitsFilter() {
      return this.$store.getters.getUnitsFilter;
    },
    provinces: {
      get() {
        return this.$store.getters.getprovinces;
      },
      set(list) {
        this.$store.commit("setprovinces", list);
      }
    },
    cities: {
      get() {
        return this.$store.getters.getcities;
      },
      set(list) {
        this.$store.commit("setcities", list);
      }
    },
    countries: {
      get() {
        return this.$store.getters.getcountries;
      },
      set(list) {
        this.$store.commit("setcountries", list);
      }
    },
    homeData() {
      return this.$store.getters.getHomeData;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setSize);
  },
  created() {
    this.windowSize = window.innerWidth;
    window.addEventListener("resize", this.setSize);
    if (this.unitsFilter == null) {
      this.$axios.get("front/unitFilters").then((res) => {
        this.$store.commit("setUnitsFilter", res.data.filters);
        this.$store.commit("setprovinces", res.data.filters.provinces);
        this.$store.commit("setcities", res.data.filters.cities);
        this.$store.commit("setcountries", res.data.filters.countries);
      });
    }
  },
  methods: {
    exitFilterMobile(e){
      console.log('e',e);
      if(e.target=='div.contentBox.drRtl.filterMobile.aos-init.aos-animate'){

      this.$emit('exitFilter',false)
      }

    },
    showIndustry(id) {
      this.$router.push(`/industry?categoryIds=${id}`);
    },
    setSize() {
      this.windowSize = window.innerWidth;
    },
    filter() {
      let query = "?";

      if (this.selectedCountry.length > 0) {
        query += "countryIds=";
        this.selectedCountry.forEach((id, index) => {
          query += `${id}${
            index == this.selectedCountry.length - 1 ? "" : ","
          }`;
        });
      }
      if (this.selectedProvinces.length > 0) {
        query += "&provinceIds=";
        this.selectedProvinces.forEach((id, index) => {
          query += `${id}${
            index == this.selectedProvinces.length - 1 ? "" : ","
          }`;
        });
      }
      if (this.selectedCity.length > 0) {
        query += "&cityIds=";
        this.selectedCity.forEach((id, index) => {
          query += `${id}${index == this.selectedCity.length - 1 ? "" : ","}`;
        });
      }
      if (this.search != "") {
        query += `&keyword=${this.search}`;
      }
      this.$emit('exitFilter',false)
      this.$router.push(`/Industry${query}`);
    },
    selectedItem(index, value, variable) {
      this.filterShowing[index] = false;
      this[variable] = value;
    },
    filterShow(index) {
      for (let i = 0; i < 4; i++) {
        if (index != i) {
          this.filterShowing[i] = false;
        } else {
          this.filterShowing[i] = !this.filterShowing[i];
        }
      }
    }
  },

  components: {
    FactoryLogo,
    SearchIcon,
    MapIcon,
    FilterIcon,
    CityIcon,
    LocationIcon,
    RegionIcon,
    Callicon,
    CategoryFilterIcon,
    EarthIcon,
    MapIcon1
  },
  watch: {
    selectedCountry(newVal) {
      if (newVal.length > 0) {
        this.provinces = this.unitsFilter.provinces.filter((item) => {
          if (newVal.find((element) => element == item.country_id)) {
            return item;
          }
        });
      } else {
        this.provinces = this.unitsFilter.provinces;
      }
    },

    selectedProvinces(newVal) {
      if (newVal.length > 0) {
        this.cities = this.unitsFilter.cities.filter((item) => {
          if (newVal.find((element) => element == item.province_id)) {
            return item;
          }
        });
      } else {
        this.cities = this.unitsFilter.cities;
      }
    }
  }
};
</script>

<style scoped>
.contentBox {
  width: 100%;
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.contentBox__text {
  text-align: center;
}

.contentBox h1 {
  font-size: 40px;
}

.contentBox p,
button {
  font-size: 18px;
  margin: 1rem 0;
}

.contentBox h1,
p {
  color: #fff;
}

.contentBox__CategorySearch {
  width: 75%;
  margin: 1rem 0;
  background-color: #fff;
  border-radius: 10px;
}

.categorySearch__Box button {
  background-color: BLUE;
  color: #000;
  padding: 10px 30px;
  border-radius: 10px;
}

.category__logo__content {
  transition: all ease 0.5s;
}
.category__logo__content:hover {
  transform: scale(1.2);
}

.categorySearch__Box {
  color: #000;
}

.filter__category__search button {
  background-color: #0d6efd;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
  font-size: 16px;
  width: 100px;
  margin-left: 1rem;
  border: 2px solid #0d6efd;
  cursor: pointer;
  transition: all ease 0.5s;
}

.filter__category__search button:hover {
  background-color: #fff;
  color: #0d6efd;
}
.filter__category__btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.boxes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.filter__box {
  position: relative;
  border-bottom: 2px solid #0d6efd;
  margin: 10px;
  display: flex;
  align-items: center;
  width: 20%;
}
.filter__box p {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #000;
  cursor: pointer;
}

.filter__item {
  flex-grow: 1;
  width: 100%;
}
.filter__input {
  border: 1px solid #333;
  width: 100%;
}

.fiter__content {
  position: absolute;
  top: 70px;
  width: 100%;
  background-color: #fff;
  padding: 5px;
}
.fiter__content form input {
  width: 100%;
  border: 1px solid #333;
  border-radius: 5px;
  background-color: transparent;
  outline: none;
  color: #333;
  padding: 5px;
}
.filter__item p {
  color: #000;
  width: 100%;
}
.filter__items {
  width: 100%;
  height: 200px;
  overflow: auto;
}
.filter__items p {
  color: #333;
  font-size: 14px;
  text-align: right;
  padding: 5px;
  cursor: pointer;
  margin: 5px 0;
}
.filter__items p:hover {
  background-color: #0d6efd;
  color: #fff;
}
.contentBox__hashtags {
  color: #fff;
  margin-top: 2rem;
  font-size: 14px;
}

.filter__box {
  color: #000;
  display: flex;
  align-items: center;
  height: 70px;
}

.contentBox__hashtags span {
  padding: 1rem 2rem;
}

.category__logo {
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  color: #fff;
}

.category__logo__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

@media only screen and (max-width: 768px) {
  .filter__box p {
    font-size: 14px;
  }
  .contentBox__text h1 {
    font-size: 25px;
    margin-top: 20px;
  }
  .contentBox__text p {
    font-size: 15px;
  }
  .boxes {
    grid-template-columns: 1fr;
    justify-content: center;
  }

  .filter__box {
    text-align: center;
    width: 90%;
    margin: 0.5 auto;
  }

  .filter__category__search {
    width: 100%;
  }
  .filter__category__search button {
    width: 90%;
    margin: 1rem auto;
  }

  .contentBox__hashtags,
  .category__logo {
    display: none;
  }
}
.industryIcon {
  border-radius: 100%;
}
#searchIndustry:focus-visible {
  outline: none;
}
</style>
<style>
.filter__box .v-label--active {
  display: none;
}
.ltrStyle .contentBox h1,
.ltrStyle .contentBox p {
  direction: ltr;
}
.contentBox__CategorySearch .v-icon {
  color: rgb(13 110 253) !important;
}
.contentBox__CategorySearch .v-input__slot:before {
  border-color: transparent !important;
}
.contentBox__CategorySearch
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-label {
  left: unset !important;
  right: 0 !important;
}
</style>
